import { render, staticRenderFns } from "./AppBenti.vue?vue&type=template&id=0d4e6501&scoped=true&"
import script from "./AppBenti.vue?vue&type=script&lang=js&"
export * from "./AppBenti.vue?vue&type=script&lang=js&"
import style0 from "./AppBenti.vue?vue&type=style&index=0&id=0d4e6501&scoped=true&lang=css&"
import style1 from "./AppBenti.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e6501",
  null
  
)

export default component.exports